import styled from 'styled-components';

import { layout } from 'utils/styles/theme';

const { max } = layout.columns;

export const Wrapper = styled.section`
  display: grid;
  grid-template-columns: repeat(${max}, minmax(0px, 1fr));
`;
